import { provideHttpClient, withFetch } from '@angular/common/http';
import {
  ApplicationConfig,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core';
import {
  provideClientHydration,
  withEventReplay,
  withIncrementalHydration,
} from '@angular/platform-browser';
import { provideRouter, withInMemoryScrolling } from '@angular/router';
import { provideTranslateService } from '@ngx-translate/core';
import { provideTranslateHttpLoader } from '@ngx-translate/http-loader';
import { routes } from './app.routes';
import { ASSET_VERSION } from './seo/seo.config';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(
      routes,
      withInMemoryScrolling({ anchorScrolling: 'enabled', scrollPositionRestoration: 'enabled' }),
    ),
    // Incremental hydration: the `@defer (on immediate; hydrate on viewport)` blocks of the
    // pages (everything below the first screen) keep the server HTML until they reach the
    // screen or are touched, and their code is not downloaded before. A tap on them
    // hydrates the block and is replayed. On client navigations they render at once.
    provideClientHydration(withEventReplay(), withIncrementalHydration()),
    provideHttpClient(withFetch()),
    // Stripe is provided by the checkout page itself (checkout.component.ts): here it put
    // ngx-stripe (64 KB) in the JavaScript of every page.
    provideTranslateService({
      // The version in the address skips copies of the translations that browsers stored
      // for a year (see ASSET_VERSION).
      loader: provideTranslateHttpLoader({
        prefix: '/assets/i18n/',
        suffix: `.json?${ASSET_VERSION}`,
      }),
      // No default language here: LanguageService sets the page's own from its address,
      // so an English page loads en.json only (it.json and en.json have the same keys).
    }),
  ],
};
